export default "__VITE_ASSET__BakFJ7SX__"